"use strict";
var SUBSCRIPTION_FAIL = 'subscription_fail';
exports.SUBSCRIPTION_FAIL = SUBSCRIPTION_FAIL;
var SUBSCRIPTION_END = 'subscription_end';
exports.SUBSCRIPTION_END = SUBSCRIPTION_END;
var SUBSCRIPTION_DATA = 'subscription_data';
exports.SUBSCRIPTION_DATA = SUBSCRIPTION_DATA;
var SUBSCRIPTION_START = 'subscription_start';
exports.SUBSCRIPTION_START = SUBSCRIPTION_START;
var SUBSCRIPTION_SUCCESS = 'subscription_success';
exports.SUBSCRIPTION_SUCCESS = SUBSCRIPTION_SUCCESS;
var SUBSCRIPTION_KEEPALIVE = 'subscription_keepalive';
exports.SUBSCRIPTION_KEEPALIVE = SUBSCRIPTION_KEEPALIVE;
//# sourceMappingURL=messageTypes.js.map


//////////////////
// WEBPACK FOOTER
// ./~/subscriptions-transport-ws/dist/messageTypes.js
// module id = 328
// module chunks = 0